import { type FC } from 'react';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
import {
    RecommendedItemsCarousel,
    type Props,
} from '../RecommendedItemsCarousel/RecommendedItemsCarousel.tsx';
import { RecommendedItemsWrapper } from '../RecommendedItemsWrapper/RecommendedItemsWrapper.tsx';

import styles from './RecommendedItemsLazy.scss';

export const RecommendedItemsLazy: FC<Props> = props => {
    const loading = (
        <RecommendedItemsWrapper>
            <div className={styles.loading}>
                <Spinner />
            </div>
        </RecommendedItemsWrapper>
    );

    return (
        <ClientSuspense fallback={loading}>
            <RecommendedItemsCarousel {...props} />
        </ClientSuspense>
    );
};
